import { PaymentMethodsContextToAchActions } from './context-to-ach-actions';
import { PaymentMethodsContextTAchForm } from './context-to-ach-form';
import { PaymentMethodsContextToList } from './context-to-list';
import { PaymentMethodsContextToListActions } from './context-to-list-actions';

const ContextToPropsNamespace = {
  List: PaymentMethodsContextToList,
  ListActions: PaymentMethodsContextToListActions,
  AchForm: PaymentMethodsContextTAchForm,
  AchActions: PaymentMethodsContextToAchActions,
};

export { ContextToPropsNamespace as ContextToProps };
